import { AxiosInstance } from "axios";
import { PublicFranchiseBranding } from "./Franchises.type";
import { ROOT_FRANCHISE_SLUG } from "../../utils/franchise/franchiseSlug";

export default class FranchisesServices {
  private axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  public async getPublicBySlug(
    slug: string = ROOT_FRANCHISE_SLUG,
  ): Promise<PublicFranchiseBranding> {
    const normalized = (slug || ROOT_FRANCHISE_SLUG).toLowerCase();
    const url = `/franchises/public/${normalized}`;
    return this.axios.get(url);
  }
}
